import { useQuery, useQueryClient, UseQueryResult } from "@tanstack/react-query"
import { carrotClient } from "#/utils/CarrotClient"
import buildCarrotApiRetryPolicy from "#/utils/CarrotApiRetryPolicy"

export type CompanyAdministrations = {
  usCarrotsOnly: boolean
}

const ENDPOINT = "getCompanyAdministrations"

const getCompanyAdministrationsCacheKey = (): (string | number)[] => [ENDPOINT]

export function useCompanyAdministrations(): UseQueryResult<CompanyAdministrations> {
  return useQuery<CompanyAdministrations>(
    getCompanyAdministrationsCacheKey(),
    () => {
      return carrotClient.getCompanyAdministrations()
    },
    {
      retry: buildCarrotApiRetryPolicy(3)
    }
  )
}

export function useCompanyAdministrationsOverride(): (attributes: CompanyAdministrations) => void {
  const queryClient = useQueryClient()
  return (attributes: CompanyAdministrations) => {
    queryClient.setQueryDefaults(getCompanyAdministrationsCacheKey(), { staleTime: Infinity, cacheTime: Infinity })
    queryClient.setQueryData(getCompanyAdministrationsCacheKey(), attributes)
  }
}
